export default "__VITE_ASSET__9_UfK0Bs__"